import React from 'react';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import { startOfDay, endOfDay, differenceInSeconds, add, sub } from 'date-fns';

import { RecordSelect, Loader, Button } from '@smartplatform/ui';
import store from '../../../store';
import { formatDateStr } from '../../../utils';
import { formatProtocolTime } from './store';

@inject('store') @observer
export default class AddStage extends React.Component {

	@observable protocol = null;
	@observable deputies = [];
	@observable type = null;
	@observable customType = null;
	@observable isLoading = false;
	@observable isSaving = false;
	
	constructor(props) {
		super(props);
		this.store = props.store;
	}
	
	resetForm = () => {
		this.type = null;
		this.customType = null;
	};
	
	onProtocolChange = async record => {
		this.isLoading = true;
		this.protocol = record;
		this.resetForm();
		if (record) {
			this.deputies = await record.deputies.find({ order: 'id asc' });
		}
		else {
			this.deputies = [];
		}
		this.isLoading = false;
	};

	renderProtocol = record => record ?
		<div className="protocol-item">
			<div className="number">№ {record.number}</div>
			<div className="time">{formatProtocolTime(record.start)} - {formatProtocolTime(record.end)}</div>
			<div className="registered">Всего: <span>{record.registered}</span></div>
			<div className="yes">За: <span>{record.yes}</span></div>
			<div className="no">Против: <span>{record.no}</span></div>
			<div className="abstained">Воздерж.: <span>{record.abstained}</span></div>
			<div className="not-voted">Не голосовал: <span>{record.notVoted}</span></div>
			<div className="type">{record.votingType}</div>
			<div className="protocol-name">{record.name}</div>
		</div>
		:
		'-';
	
	createStage = async () => {
		this.isSaving = true;
		
		this.store.notFound = [];
		
		const prevStages = await store.model.SessionQuestionStage.find({
			where: { sessionId: this.store.session.id },
			order: 'id desc',
			limit: 1,
		});
		const prevStage = prevStages.length > 0 ? prevStages[0] : null;

		const stage = new store.model.SessionQuestionStage();
		stage.sessionId = this.store.session.id;
		stage.questionId = this.props.question.id;
		stage.type = this.type;
		stage.customType = this.type ? null : (this.customType || '');
		stage.voteStart = sub(new Date(this.protocol.start), { hours: 9 });
		stage.voteEnd = sub(new Date(this.protocol.end), { hours: 9 });
		stage.period = differenceInSeconds(new Date(this.protocol.end), new Date(this.protocol.start));
		stage.number = prevStage ? prevStage.number + 1 : 1;
		stage.present = this.protocol.registered;
		// console.log('> stage', stage.present, this.protocol, this.props.question);
		stage.yesCount = this.protocol.yes;
		stage.noCount = this.protocol.no;
		stage.protocolId = this.protocol.id;
		stage.abstainCount = this.protocol.abstained;

		// дальше идет бред :( но что поделать...

		stage.statusId = /не/i.test(this.protocol.result) ? 2 : 1; // TODO: не полагаться на строку, а вычислять?
		
		let from = null;
		if (/избранных/i.test(this.protocol.votingMode)) {
			from = 'elected';
		}
		else if (/присутствующих/i.test(this.protocol.votingMode)) {
			from = 'present';
		}
		else if (/установл/i.test(this.protocol.votingMode)) {
			from = 'fixed';
		}
		stage.from = from;
		stage.fraction = this.protocol.votingMode.split(' ')[0];
		console.log('stage', stage);
		console.log('result', this.protocol.result, stage.statusId);
		
		await stage.save();
		
		console.log('creating votes...', this.deputies.length);
		
		const votesPromises = this.deputies.map(person => {
			const deputy = this.store.findDeputyByFIO(person.name.trim());
			if (!deputy) {
				if (person.name.trim() !== 'не избран') {
					this.store.notFound.push(person.name.trim());
					console.error('депутат не найден:', person.name.trim());
				}
				return;
			}
			// console.log('deputyId', deputy.id, person.name);
			if (person.yes === null && person.no === null && person.abstained === null) {
				// депутат не голосовал
				return;
			}
			const vote = new store.model.Vote();
			vote.sessionId = this.store.session.id;
			vote.questionId = stage.id;
			vote.deputyId = deputy.id;
			vote.date = stage.voteStart;
			vote.result = null;
			if (person.yes !== null) {
				vote.result = true;
			}
			else if (person.no !== null) {
				vote.result = false;
			}
			// console.log('> vote', vote);
			return vote.save();
		});
		
		await Promise.all(votesPromises);
		
		const membersPromises = this.deputies.filter(person => !!person.present).map(person => {
			const deputy = this.store.findDeputyByFIO(person.name.trim());
			if (!deputy) {
				// console.log('depuity not found:', person.name.trim());
				return;
			}
			const member = new store.model.SessionMember();
			member.sessionId = this.store.session.id;
			member.deputyId = deputy.id;
			member.userId = deputy.userId;
			member.date = stage.voteStart;
			member.end = stage.voteEnd;
			member.code = 'deputy';
			member.delay = 0;
			return member.save();
		});
		console.log('membersPromises', membersPromises.length);
		await Promise.all(membersPromises);
		
		this.isSaving = false;
		this.protocol = null;
		this.resetForm();
		this.props.onUpdate();
	};
	
	onTypeChange = record => {
		this.type = record;
	};
	
	onCustomTypeChange = e => {
		this.customType = e.target.value;
	};
	
	render() {
		const { onCancel } = this.props;
		
		const disabled = !this.type && (!this.customType || this.customType.trim().length === 0);
		
		const date0 = add(startOfDay(new Date(this.store.date)), { hours: 9 });
		const date1 = add(endOfDay(new Date(this.store.date)), { hours: 9 });

		const filter = {
			where: {
				and: [
					{ start: { gte: date0 }},
					{ end: { lte: date1 }},
				]
			},
		};

		return <div className="stage-form">
			<div className="block">
				<RecordSelect
					model={store.model.ConfProtocol}
					computed={this.renderProtocol}
					value={this.protocol}
					className="drop-down-md protocol-select"
					onChange={this.onProtocolChange}
					showValue={this.protocol ? this.renderProtocol(this.protocol) : <div className="select-hint">Выберите протокол</div>}
					filter={filter}
					// isRequired
				/>
			</div>
			{this.protocol && this.deputies.length > 0 && !this.isSaving && <div className="import-info">
				<span>Тип голосования:</span>
				<RecordSelect
					model={store.model.QuestionStage}
					filter={{order:'weight desc, id desc'}}
					property="name"
					className="drop-down-md"
					value={this.type}
					onChange={this.onTypeChange}
					empty="Другое"
					showValue={this.type ? this.type.name : <div className="select-hint">Выберите тип</div>}
				/>
				<input
					type="text"
					value={this.customType || ''}
					onChange={this.onCustomTypeChange}
					placeholder="Другое"
					disabled={this.type !== null}
				/>
				<Button className="btn-primary" onClick={this.createStage} disabled={disabled}>Добавить</Button>
				<Button onClick={onCancel}>Отмена</Button>
			</div>}
			{this.isSaving && <><Loader size={18} /> Идет импорт...</>}
		</div>;
	}
}
